const state = {
    data: {},
    keys: {
        '0': 'Protocolo',
        '1': 'Data1',
        '2': 'Registro',
        '3': 'Nome',
        '4': 'Data',
        '5': 'Idade',
        '6': 'CPF',
        '7': 'Convenio',
        '8': 'CEP',
        '9': 'Endereco',
        '10': 'EnderecoNum',
        '11': 'Cidade'
    }
}

const getters = {
    getSpearheadData(state) {
        return state.data;
    }
}

const actions = {}

const mutations = {
    async setSpearheadData(data, callType) {
        const callInfo = data.split('||');
        let payload = {
            protocol: "",
            queue: "",
            phone: "",
            cpf: "",
            entry: "",
            type: 'phone',
        }
        if(!callInfo.length){
            state.data = payload;
            return
        }

        if(callType === 'queueIncoming'){
            payload.queue = callInfo[0]
            payload.phone = callInfo[1]
            payload.entry = callInfo[3]
        } else if(callType === 'queueIncomingNew'){
            payload.queue = callInfo[0]
            payload.phone = callInfo[1]
            payload.entry = callInfo[2]
        }else if(callType === 'incomingCrv'){
            payload.queue = callInfo[0]
            payload.originPhone = callInfo[1]
            payload.clientName = callInfo[5]
            payload.contactPhone = callInfo[6]
            payload.cpf = callInfo[3]
            payload.etapa = callInfo[4]
            payload.email = callInfo[7]
        } else if(callType === 'outgoing'){
            payload.queue = 'Ligação ativa'
            payload.phone = callInfo[0]
        } else if(callType === 'blindTransfer'){
            payload.queue = 'Transferência'
            payload.phone = callInfo[0]
        }

        state.data = payload;
    },

    async delSpearheadData() {
        state.data = {}
    },

    async setChatData(data) {
        let obj = {
            Protocolo: data.protocol,
            phone: data.phone,
            type: 'chat',
            name: data.name,
            queue: data.queue
        };
        
        state.data = obj;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
